import React from 'react';

const Share2Icon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1334 5.14166C15.8 6.3 16.95 8.14166 17.1834 10.2667"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.90833 10.3083C3.12499 8.19168 4.25833 6.35002 5.90833 5.18335L2.90833 10.3083Z" fill="#42389D" />
    <path
      d="M2.90833 10.3083C3.12499 8.19168 4.25833 6.35002 5.90833 5.18335"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.82501 17.45C7.79168 17.9417 8.89168 18.2167 10.05 18.2167C11.1667 18.2167 12.2167 17.9667 13.1583 17.5083"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.05 6.41666C11.3295 6.41666 12.3667 5.37945 12.3667 4.09999C12.3667 2.82053 11.3295 1.78333 10.05 1.78333C8.77054 1.78333 7.73334 2.82053 7.73334 4.09999C7.73334 5.37945 8.77054 6.41666 10.05 6.41666Z"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.02498 16.6C5.30444 16.6 6.34165 15.5628 6.34165 14.2833C6.34165 13.0039 5.30444 11.9667 4.02498 11.9667C2.74552 11.9667 1.70831 13.0039 1.70831 14.2833C1.70831 15.5628 2.74552 16.6 4.02498 16.6Z"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.975 16.6C17.2545 16.6 18.2917 15.5628 18.2917 14.2833C18.2917 13.0039 17.2545 11.9667 15.975 11.9667C14.6955 11.9667 13.6583 13.0039 13.6583 14.2833C13.6583 15.5628 14.6955 16.6 15.975 16.6Z"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Share2Icon;
